import { render, staticRenderFns } from "./BarCalendarMinimalized.vue?vue&type=template&id=3c91a458"
import script from "./BarCalendarMinimalized.vue?vue&type=script&lang=js"
export * from "./BarCalendarMinimalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports